import { Button, Dialog } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'

type Props = {
  isOpen: boolean

  onConfirm: () => void
  setIsOpen: (isOpen: boolean) => void
}

export function PreemptionCodeErrorDialog(props: Props) {
  const { t } = useTranslation()

  return (
    <Dialog
      isOpen={props.isOpen}
      mobileMode="bottomSheet"
      setIsOpen={props.setIsOpen}
      size="sm"
      title={t('preemptionCode.maxReservationsDialog.title')}
      trigger={null}
    >
      <div className="p-4">
        <p className="mb-6">
          {t('preemptionCode.maxReservationsDialog.message')}
        </p>
        <Button className="mb-2" fullWidth onClick={() => props.onConfirm()}>
          {t('preemptionCode.maxReservationsDialog.confirmBtn')}
        </Button>
        <Button
          fullWidth
          onClick={() => props.setIsOpen(false)}
          variant="outline"
        >
          {t('preemptionCode.maxReservationsDialog.closeBtn')}
        </Button>
      </div>
    </Dialog>
  )
}
